module.exports = __webpack_public_path__ + "img/bobeio_bobocoin.gm.cc32caa.png";